import script from "./FeedbackSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackSection.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackSection.vue?vue&type=style&index=0&id=23e30d27&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e30d27"]])

export default __exports__